import { AbstractCreateEntityComponent } from '@abstracts/entities/create-entity';
import { HttpParams } from '@angular/common/http';
import { Component, Inject, Injector, OnInit } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { RfidCard } from '@models/rfidCard';
import { RfidCardsService } from '@services/entity/rfidCards.service';
import { ToastService } from '@services/toast/toast.service';

@Component({
  selector: 'app-create-rfid-card',
  templateUrl: './create-rfid-card.component.html',
  styleUrls: ['./create-rfid-card.component.scss']
})
export class CreateRfidCardComponent extends AbstractCreateEntityComponent implements OnInit {

  public className = 'CreateRfidCardComponent';

  public customerId: number;

  constructor(
    @Inject('BASE_URL') private baseUrl: string,
    private rfidCardsService: RfidCardsService,
    public toastService: ToastService,
    injector: Injector) {
    super(rfidCardsService, injector);
  }

  createForm() {
    this.formService.validators = {
      idTag: [Validators.required],
    }

    this.formService.form = new UntypedFormGroup({
      idTag: new UntypedFormControl('', this.formService.validators['idTag']),
    });

    document.getElementById('idTag').focus();
  }

  onSubmit(formValue) {

    if (formValue.idTag.length < 8) {
      this.toastService.clear();
      this.toastService.error(`Eingabefehler: RFID-Kartennummer benötigt min. 8-Zeichen.`, 0, true);
      return;
    }
    var rfidCard = new RfidCard(formValue);


    if (this.customerId) {
      this.rfidCardsService.createRfidCardForCustomer(this.customerId, rfidCard).subscribe(newRfidCard => {
        this.rfidCardsService.emitCreated(newRfidCard);
        this.toastService.success('RFID Karte wurde angelegt.');
        this.formService.form.reset();
      }, error => {
        this.toastService.error('RFID Karte konnte nicht angelegt werden.');
      })
    }
    else {
      this.rfidCardsService.createRfidCard(rfidCard).subscribe(newRfidCard => {
        this.rfidCardsService.emitCreated(newRfidCard);
        this.toastService.success('RFID Karte wurde angelegt.');
        this.formService.form.reset();
      }, error => {
        if (error == 'Card_Exists') {
          this.toastService.error(`Die RFID Karte "${rfidCard.idTag}" existiert bereits.`);
        } else {
          this.toastService.error('RFID Karte konnte nicht angelegt werden.');
        }
      })
    }
  }

  onInput(event: Event) {
    this.toastService.clear();
    const inputValue = (event.target as HTMLInputElement).value;
    const regexNonHex: RegExp = /[^0-9A-Fa-f]/g;
  
    let replacedValue = inputValue.replace(regexNonHex, '').toLowerCase();
  
    if (regexNonHex.test(inputValue)) {
      this.toastService.error(`Eingabefehler: Nur hexadezimale Zahlen erlaubt`, 0, true);
    }
  
    this.formService.form.get('idTag')?.setValue(replacedValue, { emitEvent: false });
  }
}
